import { render, staticRenderFns } from "./activities.vue?vue&type=template&id=29d8f74d&scoped=true&lang=pug&"
import script from "./activities.vue?vue&type=script&lang=coffee&"
export * from "./activities.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d8f74d",
  null
  
)

export default component.exports